import React, {useEffect, useState} from 'react';
import './index.scss';
import Wrapper from '../../components/Wrapper';
import {Helmet} from 'react-helmet';
import DashboardHeader from '../../components/DashboardHeader';
import Input from '../../components/Input';
import {useDispatch, useSelector} from 'react-redux';
import {useLocation, useNavigate} from 'react-router-dom';
import {useLazyGetCustomCategoriesQuery} from '../../store/builder/inspections.api';
import {setLoader} from '../../store/builder/reducer';
import FormRow from '../../components/Forms/FormRow';
import moment from 'moment';
import {useDebounce} from '../LogSheets/hooks';
import {setDefaultState} from '../CreateNewForm/service/createForm.slice';
import CustomPaginate from '../../components/PaginateComponent';
import useLoader from '../../global/UseLoadingHandler';
import {useTranslation} from '../../hooks/useTranslation';

const Forms = () => {
  const userInfo = useSelector(state => state?.rootReducer?.loginSlice?.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const {t} = useTranslation();
  const userType =
    location.state?.userType === 'corporate' ? 'corporate' : 'admin';
  const [list, setList] = useState([]);
  const [search, setSearch] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const debouncedSearchValue = useDebounce(search, 500);

  const [
    getCustomsForms,
    {
      data: getCustomsFormsData,
      isError: getCustomsFormsIsError,
      isFetching: getCustomsFormsIsLoading,
      error: getCustomsFormsError,
      isSuccess: getCustomsFormsIsSuccess,
    },
  ] = useLazyGetCustomCategoriesQuery();

  const getFormsList = () => {
    if (userType === 'corporate') {
      getCustomsForms({
        page: currentPage,
        is_corporate: true,
        search: debouncedSearchValue,
      });
    } else {
      getCustomsForms({
        page: currentPage,
        is_corporate: false,
        search: debouncedSearchValue,
      });
    }
  };

  useEffect(() => {
    getFormsList();
  }, [debouncedSearchValue, userType, currentPage]);

  useLoader([getCustomsFormsIsLoading]);

  useEffect(() => {
    if (getCustomsFormsData?.data?.length > 0) {
      setList(
        getCustomsFormsData?.data?.map(el => {
          return {...el, action_status: false};
        }),
      );
    }
  }, [getCustomsFormsIsSuccess, getCustomsFormsData]);

  const handleSearch = e => {
    setSearch(e.target.value);
    setCurrentPage(1);
  };

  const handlePageClick = page => {
    setCurrentPage(page.selected + 1);
    window.scrollTo(0, 0);
  };

  return (
    <Wrapper>
      <Helmet>
        <title>{t('forms.pageTitle')}</title>
      </Helmet>
      <DashboardHeader
        title={t('forms.title')}
        showBtn={true}
        type='forms'
        action={() => {
          dispatch(setDefaultState());
          if (userType === 'corporate') {
            navigate('/corporate/forms/create-form', {
              state: {userType: userType},
            });
          } else {
            navigate('/forms/create-form');
          }
        }}
      />
      <div className='forms'>
        <div className='forms__content'>
          <div className='forms__search'>
            <Input
              type='text'
              placeholder={t('forms.searchPlaceholder')}
              name='form_name'
              id='form_name'
              image={'/assets/icons/search.svg'}
              maxwidth={264}
              onChange={handleSearch}
            />
          </div>
          <div className='forms__table'>
            <div className='forms__table-header'>
              <div className='forms__table-th'>{t('forms.tableHeaders.name')}</div>
              <div className='forms__table-th'>{t('forms.tableHeaders.dateOfCreation')}</div>
              <div className='forms__table-th'>{t('forms.tableHeaders.numberOfFields')}</div>
              <div className='forms__table-th'>{t('forms.tableHeaders.dateLastModified')}</div>
              <div className='forms__table-th'>{t('forms.tableHeaders.createdBy')}</div>
              <div className='forms__table-th'></div>
            </div>
            <div className='forms__table-body'>
              {list?.length > 0 ? (
                list?.map(item => (
                  <FormRow
                    item={item}
                    key={item.id}
                    setList={setList}
                    getFormsList={getFormsList}
                    userType={userType}
                  />
                ))
              ) : (
                <div
                  style={{
                    width: '100%',
                    height: '205px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    paddingTop: 100,
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexDirection: 'column',
                    }}
                  >
                    <div className='expired__box-img' style={{margin: '0'}}>
                      <img src='/assets/no-data.svg' alt='no-data' />
                    </div>
                    <p className='no-payment-text'>{t('forms.messages.noData')}</p>
                  </div>
                </div>
              )}
            </div>
          </div>
          <CustomPaginate
            pageCount={getCustomsFormsData?.pages}
            handlePageClick={handlePageClick}
          />
        </div>
      </div>
    </Wrapper>
  );
};

export default Forms;
